import { storageKeys } from '../../../utils/browser-storage/storage-keys';
import qualityEventsHelpers from '../quality-events.helpers';

export const SCHOOL_ACCOUNT_QUALITY_EVENTS = {
    newSchoolCreated() {
        qualityEventsHelpers.track({
            extra: JSON.stringify(Date.now()),
            type: 'NewSchoolCreated',
            user_id: window.storage.getItem(storageKeys.user.userId)
        });
    },
    schoolEntry() {
        qualityEventsHelpers.track({
            extra: JSON.stringify(Date.now()),
            type: 'SchoolEntry'
        });
    },
    copySchoolCode(schoolId: number) {
        qualityEventsHelpers.track({
            type: 'copy_school_code',
            extra: JSON.stringify({ schoolId })
        });
    },
    shareSchoolFolders(schoolId: number) {
        qualityEventsHelpers.track({
            type: 'share_school_folders',
            extra: JSON.stringify({ school_id: schoolId })
        });
    },
    unshareSchoolFolders(schoolId: number) {
        qualityEventsHelpers.track({
            type: 'unshare_school_folders',
            extra: JSON.stringify({ school_id: schoolId })
        });
    }
};
